import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/gumservices/client.service';
import { ClientModel } from 'src/app/models/gum-models/client.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { User } from 'src/app/models/user';
import { UsersService } from 'src/app/services/users.service';
import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-gum-client-form',
  templateUrl: './gum-client-form.component.html',
  styleUrls: ['./gum-client-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatInput,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatTabGroup,
    MatCardModule,
    MatTabsModule,
    MatCheckboxModule,
  ],
})
export class GumClientFormComponent implements OnInit {
  form!: FormGroup;
  isEditMode = false;
  clientId: string | null = null;
  formEnabled = true;
  currentUser: User | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
    private usersService: UsersService,
    private gumOrganizationsService: GumOrganizationsService
  ) {}

  ngOnInit(): void {
    this.initForm();

    this.usersService.getSessionCurrentUser().subscribe((user) => {
      this.currentUser = user;
    });

    this.route.params.subscribe((params) => {
      this.clientId = params['id'] ?? null;
      if (this.clientId) {
        this.isEditMode = true;
        this.loadClient(this.clientId);
      }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      nom: ['', Validators.required],
      address: ['', Validators.required],
      zipcode: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      siret: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
    });
  }

  loadClient(id: string): void {
    this.clientService.getClient(id).subscribe((client) => {
      this.form.patchValue(client);
      this.formEnabled = !!client.enabled;
    });
  }

  onEnabledChanged(enabled: boolean): void {
    this.formEnabled = enabled;
  }

  submit(): void {
    if (this.form.invalid) return;

    const currentOrg = this.gumOrganizationsService.getCurrentOrganization();

    if (!currentOrg) {
      console.error('Aucune organisation sélectionnée dans la top bar.');
      return;
    }

    const client: ClientModel = {
      ...this.form.value,
      enabled: this.formEnabled,
      partnerId: currentOrg.id,
      nexusType: 'client',
    };

    if (this.isEditMode && this.clientId) {
      this.clientService
        .updateClient(this.clientId, client)
        .subscribe(() => this.router.navigate(['/clients']));
    } else {
      this.clientService
        .createClient(client)
        .subscribe(() => this.router.navigate(['/clients']));
    }
  }

  cancel(): void {
    this.router.navigate(['/clients']);
  }
}
